<template>
  <div class="submenu">
    <a-page-header>
      <template slot="extra">
        <div>
          <a-menu v-model="current" mode="horizontal">
            <a-menu-item
              key="home"
              class="s-s-font1"
              v-bind:class="['', menu == 1 ? activeClass : '']"
              @click="$router.push('/pages/dashboard').catch(() => {})"
            >
              <div><i class="far fa-home-alt"></i>&nbsp;홈</div>
              <div
                class="s-s-ud"
                v-bind:class="['', menu == 1 ? activeClass : '']"
              ></div>
            </a-menu-item>
            <a-menu-item
              key="rank"
              class="s-s-font1"
              v-bind:class="['', menu == 2 ? activeClass : '']"
              @click="$router.push('/pages/pointhistory').catch(() => {})"
            >
              <div><i class="fas fa-history"></i>&nbsp;내 수익 현황</div>
              <div
                class="s-s-ud"
                v-bind:class="['', menu == 2 ? activeClass : '']"
              ></div>
            </a-menu-item>
            <!-- <a-menu-item key="overview" class="s-s-font1"  v-bind:class="['', menu==3 ? activeClass : '']"  @click="$router.push('/pages/requestwithdraw').catch(() => {})">
                        <div> <i class="fal fa-won-sign"></i>&nbsp; 출금 신청 </div>
                        <div class="s-s-ud " v-bind:class="['', menu==3 ? activeClass : '']"> </div>
                    </a-menu-item> -->
            <a-menu-item
              key="favorite"
              class="s-s-font1"
              v-bind:class="['', menu == 4 ? activeClass : '']"
              @click="$router.push('/pages/mycampaign').catch(() => {})"
            >
              <div>
                <i class="fas fa-list-ul"></i>&nbsp; 내 진행 전체 캠페인
              </div>
              <div
                class="s-s-ud"
                v-bind:class="['', menu == 4 ? activeClass : '']"
              ></div>
            </a-menu-item>
          </a-menu>
        </div>
      </template>
    </a-page-header>
  </div>
</template>

<script>
import { chkLicense } from "../../../views/components/fnc"
export default {
  props: {
    menu: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      activeClass: "active",
      current: "",
      allowAnalytics: false
    }
  },
  computed: {
    getName () {
      return this.$store.state.AppActiveUser.displayName
    },
    getUid () {
      return this.$store.state.AppActiveUser.uid
    },
    getIncludeKeyword () {
      return this.$store.state.AppActiveUser.includekeyword
    },
    getIsAgency () {
      return this.$store.state.AppActiveUser.isagency
    },
    getIsAnalytics () {
      return this.$store.state.AppActiveUser.isanalytics
    }
  },
  mounted () {
    if (chkLicense(null)) {
      this.allowAnalytics = true
    }
  },
  methods: {
    onBack () {
      this.$router.push("/").catch(() => {})
    }
  }
}
</script>

<style>
.submenu .ant-page-header {
  padding-top: 12px !important;
  padding-bottom: 12px !important;
  height: 72px !important;
  box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.03);
  background-color: #ffffff;
}

.submenu .ant-page-header-heading {
  margin-top: 0px !important;
}

.submenu .ant-menu {
  background-color: white !important;
}

/* .submenu .ant-menu-item {
  color: black !important;
} */

.s-s-font1 {
  font-family: "Noto Sans KR", sans-serif;
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  color: #7d7d7d !important;
}

.s-s-font1.active {
  color: #0264fb !important;
}
.s-s-font1:hover {
  color: #0264fb !important;
}

.s-s-ud.active {
  width: 100%;
  height: 2px;
  margin-top: 10px;
  border: 2px solid #0464fb;
}

.s-s-ud {
  width: 100%;
  height: 2px;
  margin-top: 10px;
  border: 2px solid white;
}
</style>
